// Reserve3.jsx
import React from "react";
import { STRAIGHT_OPTIONS } from "./straightOptions"; // 경로는 폴더 구조에 맞게 수정
import radioOn from "../../../../assets/icons/Select/radio_checked_color.svg"
import radioOff from "../../../../assets/icons/Select/radio_unchecked.svg"

// ──────────────────────────────────────────────
// Step3 : 바로가기 선택
// ──────────────────────────────────────────────
const Reserve3 = ({ straightKey, setStraightKey }) => {
  return (
    <div className="space-y-[16px] p-[16px]">
      <h2 className="text-t2">바로가기를 설정해 보세요</h2>
      <p className="text-b1 text-text-subtler">
        예약한 시간에 알림을 누르면, 선택한 화면으로 바로 이동해요.
      </p>

      <div className="mt-[12px] space-y-[12px]">
        {STRAIGHT_OPTIONS.map((opt) => {
          const selected = straightKey === opt.key;
          return (
            <button
              key={opt.key}
              type="button"
              onClick={() => setStraightKey(opt.key)}
              className={`w-full text-left rounded-[16px] border px-[12px] py-[12px] flex gap-[12px] ${selected
                ? "border-border-primary bg-surface-light-primary-light"
                : "border-border-default bg-surface-light-white-layered"
                }`}
            >
              <img src={selected ? radioOn : radioOff} alt={selected ? "선택됨" : "미선택"} className="w-[24px] h-[24px]" />
              <div className="flex-1">
                <div className="text-b1 text-text-default">{opt.title}</div>
                {opt.desc && (
                  <div className="text-c2 text-text-subtler mt-[4px]">
                    {opt.desc}
                  </div>
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Reserve3;